import Input from '~/components/commonUi/Input/Input';
import Button from '~/components/commonUi/Button/Button';
import { getStore } from '~/mobx/AppStore';
import { observer } from 'mobx-react';

export interface LoginFormProps {
    username: string;
    password: string;
    onUsernameChange: (value: string) => void;
    onPasswordChange: (value: string) => void;
    onSubmit: () => void;
    disabledSubmit: boolean;
}

const LoginForm = (props: LoginFormProps) => {
    const { username, password, onUsernameChange, onPasswordChange, onSubmit, disabledSubmit } = props;

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        onSubmit();
    };

    return (
        <form action="/election-logout" method="post" onSubmit={handleSubmit}>
            {/* Username input row */}
            <div className="flex flex-col items-start w-full md:w-[70%] lg:w-[50%] mb-4 md:flex-row md:items-center">
                <label className="w-2/6 font-normal mb-4 md:mb-0" htmlFor="username">
                    Brukernavn
                </label>
                <div className="w-full md:w-4/6">
                    <Input
                        required
                        id="username"
                        name="username"
                        extendedClassName="w-full md:w-4/6"
                        onChange={(event) => onUsernameChange(event.target.value)}
                        value={username}
                        testId="username-input"
                    />
                </div>
            </div>
            {/* Password input row with button */}
            <div className="flex flex-col items-start w-full  md:w-[70%] lg:w-[50%] mb-4 md:flex-row md:items-center">
                <label className="w-2/6 font-normal mb-4 md:mb-0" htmlFor="password">
                    Passord
                </label>
                <div className="w-full flex flex-col gap-6 md:flex-row md:items-center flex-1">
                    <Input
                        required
                        id="password"
                        name="password"
                        type="password"
                        extendedClassName="md:w-4/6 w-full"
                        onChange={(event) => onPasswordChange(event.target.value)}
                        value={password}
                        testId="password-input"
                    />
                    <Button
                        type="submit"
                        size="small"
                        btnText="LOGG INN"
                        testId="btn-submit-login"
                        extendedClassName="w-fit"
                        disabled={disabledSubmit}
                    />
                </div>
            </div>
        </form>
    );
};

const LoginFormWithStore = () => {
    const { loginPageStore } = getStore();

    return (
        <LoginForm
            username={loginPageStore.username}
            password={loginPageStore.password}
            onUsernameChange={loginPageStore.setUsername}
            onPasswordChange={loginPageStore.setPassword}
            onSubmit={loginPageStore.submitLogin}
            disabledSubmit={loginPageStore.isLoggingIn}
        />
    );
};

export default observer(LoginFormWithStore);
